// See: backend/docs/driver-scheduler.md §11 — POST /optimize-day
//
// Tek bir değişiklik için diff satırı. Eski sürücü → yeni sürücü, cost delta, sebep.

import React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AddIcon from "@mui/icons-material/Add";

const OptimizeDayChangeRow = ({ change }) => {
  if (!change) return null;

  const isNew = !change.oldDriverId;
  const isDriverChange = change.oldDriverId && change.newDriverId && change.oldDriverId !== change.newDriverId;
  const deltaText = formatDelta(change.costDelta);
  const reasoning = formatReasoning(change.reasoning);

  return (
    <div className={`optimize-change-row ${isNew ? "optimize-change-row--new" : ""}`}>
      <div className="optimize-change-row__service">
        <div className="optimize-change-row__service-name">{change.serviceName}</div>
        {change.startTime && (
          <div className="optimize-change-row__service-time">
            {change.startTime} → {change.endTime}
          </div>
        )}
      </div>

      <div className="optimize-change-row__transition">
        {isNew ? (
          <>
            <AddIcon fontSize="small" style={{ color: "#2e7d32" }} />
            <span className="optimize-change-row__new-driver">{change.newDriverName || "?"}</span>
          </>
        ) : isDriverChange ? (
          <>
            <span className="optimize-change-row__old-driver">{change.oldDriverName || "?"}</span>
            <ArrowForwardIcon fontSize="small" style={{ color: "#666" }} />
            <span className="optimize-change-row__new-driver">{change.newDriverName || "?"}</span>
          </>
        ) : (
          <span style={{ color: "#888" }}>—</span>
        )}
      </div>

      <div className="optimize-change-row__delta">
        {deltaText && (
          <span
            className={`optimize-change-row__delta-value ${
              change.costDelta < 0 ? "is-negative" : change.costDelta > 0 ? "is-positive" : ""
            }`}
          >
            {deltaText}
          </span>
        )}
      </div>

      {reasoning && <div className="optimize-change-row__reasoning">{reasoning}</div>}
    </div>
  );
};

function formatDelta(d) {
  if (typeof d !== "number") return null;
  const sign = d > 0 ? "+" : "";
  return `${sign}${d.toFixed(2)}`;
}

function formatReasoning(r) {
  if (!r || typeof r !== "object") return null;
  const parts = [];
  if (r.prevTrip?.name) parts.push(`Önceki: ${r.prevTrip.name} (${r.prevTrip.endTime || ""})`);
  if (typeof r.chainDeltaMin === "number" && r.chainDeltaMin !== 0) {
    parts.push(`Δ ${r.chainDeltaMin > 0 ? "+" : ""}${r.chainDeltaMin}dk yol`);
  }
  if (typeof r.chainDeltaKm === "number" && r.chainDeltaKm !== 0) {
    parts.push(`Δ ${r.chainDeltaKm > 0 ? "+" : ""}${r.chainDeltaKm}km`);
  }
  if (typeof r.homeDeltaKm === "number" && r.homeDeltaKm !== 0) {
    parts.push(`Δ ${r.homeDeltaKm > 0 ? "+" : ""}${r.homeDeltaKm}km ev`);
  }
  if (typeof r.restPenaltyDelta === "number" && r.restPenaltyDelta !== 0) {
    parts.push(`Δ ${r.restPenaltyDelta > 0 ? "+" : ""}${r.restPenaltyDelta} dinlenme`);
  }
  return parts.length > 0 ? parts.join(" • ") : null;
}

export default OptimizeDayChangeRow;
